<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :disabled="disabled"
      :min="minTime"
      type="time"
      class="form-control time-picker-input"
      @change="onChange"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TimeToInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    minTime: {
      type: Number,
      default: 1
    },

    inputLabel: {
      type: String,
      default: 'Время окончания'
    },

    inputHint: {
      type: String,
      default: undefined
    }
  },

  methods: {
    onChange(event) {
      const timeOf = this.form.application.time_of
      if (event.target.value && event.target.value === timeOf) {
        const [hours, minutes] = timeOf.split(':').map(Number)
        if (isNaN(hours) || isNaN(minutes)) {
          event.target.value = '00:00'
        }

        const offsetMinutes = 1
        const totalMinutes = hours * 60 + minutes + offsetMinutes

        const newHours = Math.floor(totalMinutes / 60) % 24
        const newMinutes = totalMinutes % 60

        event.target.value = `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`
        this.$emit('input', event.target.value)
      }
    }
  }
}
</script>
